import { UiViewModelState } from '../UiState';
import { areMoreIncrementalsNeededQuery } from './areMoreIncrementalsNeededQuery';
import { canSubmitWorkCenterWeekQuery } from './canSubmitWorkCenterWeekQuery';
import { getCompaniesThatCanBeAssociatedQuery } from './getCompaniesThatCanBeAssociatedQuery';
import { getDaysOfWeekQuery } from './getDaysOfWeekQuery';
import { getFirstActiveWeekQuery } from './getFirstActiveWeekQuery';
import { getWeekQuery } from './getWeekQuery';
import { getWorkCenterWeekQuery } from './getWorkCenterWeekQuery';
import { hasUnsavedChangesForWorkCenterWeekQuery } from './hasUnsavedChangesForWorkCenterWeekQuery';
import { hasUnsavedChangesQuery } from './hasUnsavedChangesQuery';
import { hasWorkCenterFilterQuery } from './hasWorkCenterQuery';
import { isCurrentWeekQuery } from './isCurrentWeekQuery';
import { isDayReadOnlyQuery } from './isDayReadOnlyQuery';
import { isWorkCenterIncludedInFilterQuery } from './isWorkCenterIncludedInFilterQuery';

// Queries you can ask the uiState for
// https://martinfowler.com/bliki/CQRS.html
export class UiQueries {
  // eslint-disable-next-line no-useless-constructor, no-empty-function
  constructor(protected uiState: UiViewModelState) {}

  public getWeek = getWeekQuery;

  public getWorkCenterWeek = getWorkCenterWeekQuery;

  public isDayReadOnly = isDayReadOnlyQuery;

  public hasWorkCenterFilter = hasWorkCenterFilterQuery;

  isWorkCenterIncludedInFilter = isWorkCenterIncludedInFilterQuery;

  getFirstActiveWeek = getFirstActiveWeekQuery;

  areMoreIncrementalsNeeded = areMoreIncrementalsNeededQuery;

  getDaysOfWeek = getDaysOfWeekQuery;

  isCurrentWeek = isCurrentWeekQuery;

  hasUnsavedChangesForWorkCenterWeek = hasUnsavedChangesForWorkCenterWeekQuery;

  hasUnsavedChanges = hasUnsavedChangesQuery;

  getCompaniesThatCanBeAssociated = getCompaniesThatCanBeAssociatedQuery;

  canSubmitWorkCenterWeek = canSubmitWorkCenterWeekQuery;
}
